import { useRolodexEntriesTwoPhaseFetchCachedById } from 'features/knowledgeDocumentViewer/hooks/useRolodexEntriesCachedById'
import { useMemo } from 'react'
import {
  RolodexAdvancedFilterOperator,
  RolodexEntryType,
  RolodexFilterOp,
  SystemDocumentEntry,
} from 'types'

export function useOffPageConnectorDocuments(
  searchText: string | undefined,
  siteID: string
) {
  const loadOptions = useMemo(() => {
    if (!searchText)
      return {
        type: [RolodexEntryType.SYSTEM_DOCUMENT],
        tags: { site: siteID },
        limit: 0,
      }

    const escapedText = searchText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

    return {
      type: [RolodexEntryType.SYSTEM_DOCUMENT],
      tags: { site: siteID },
      advanced_filter: {
        operator: RolodexAdvancedFilterOperator.OR,
        filters: [
          {
            field: 'data',
            key: 'title',
            op: RolodexFilterOp.REGEX,
            value: escapedText,
          },
          {
            field: 'data',
            key: 'drawing_number',
            op: RolodexFilterOp.REGEX,
            value: escapedText,
          },
        ],
      },
      limit: 100000,
    }
  }, [searchText, siteID])

  const { data, isLoading, error } =
    useRolodexEntriesTwoPhaseFetchCachedById<SystemDocumentEntry>(loadOptions)

  return {
    systemDocumentEntries: data ?? [],
    isLoading,
    error,
  }
}
